<div class="announcement-dialog" [ngClass]="'type-' + current.type">

    <h1 mat-dialog-title>
        <mat-icon class="type-icon">{{ iconFor(current.type) }}</mat-icon>
        <span class="title-text">{{ current.title }}</span>
    </h1>

    <div mat-dialog-content>
        <!--
          A PLAIN [innerHTML] BINDING, DELIBERATELY. Angular's DomSanitizer strips scripts and
          event handlers on the way in, and the server has already rendered this through a
          complete tag allowlist. Never wrap it in bypassSecurityTrustHtml — that removes the
          second of the two layers and leaves admin-authored markup rendering unchecked.
        -->
        <div class="announcement-body" [innerHTML]="current.bodyHtml"></div>

        <a *ngIf="current.ctaLabel && current.ctaUrl"
            mat-raised-button color="primary" class="announcement-cta"
            [href]="current.ctaUrl" target="_blank" rel="noopener noreferrer">
            {{ current.ctaLabel }}
        </a>
    </div>

    <div mat-dialog-actions class="announcement-actions">

        <!-- Paging. Hidden entirely for a single announcement rather than shown disabled. -->
        <div class="paging" *ngIf="announcements.length > 1">
            <button mat-icon-button (click)="previous()" [disabled]="index === 0" aria-label="Previous">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="paging-count">{{ index + 1 }} of {{ announcements.length }}</span>
            <button mat-icon-button (click)="next()" [disabled]="index === announcements.length - 1" aria-label="Next">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>

        <span class="spacer"></span>

        <!-- Acknowledgement replaces every other action: a critical notice has one way out. -->
        <ng-container *ngIf="current.requiresAcknowledgement; else ordinaryActions">
            <button mat-raised-button color="warn" (click)="acknowledge()">
                I understand
            </button>
        </ng-container>

        <ng-template #ordinaryActions>
            <button mat-button (click)="snooze()">Remind me later</button>
            <button mat-button *ngIf="current.dismissible" (click)="dismiss()">Don't show again</button>
            <button mat-raised-button color="primary" (click)="close()">Close</button>
        </ng-template>

    </div>
</div>
